/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei/useGLTF";

import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";

type GLTFResult = GLTF & {
  nodes: {
    group24878451: THREE.Mesh;
    group1127867106: THREE.Mesh;
    group1139380957: THREE.Mesh;
    group1164002630: THREE.Mesh;
    group1215636041: THREE.Mesh;
    group1262710399: THREE.Mesh;
    group1312281953: THREE.Mesh;
    group1344882062: THREE.Mesh;
    group1412601270: THREE.Mesh;
    group1420559667: THREE.Mesh;
    group1506597832: THREE.Mesh;
    group1625508101: THREE.Mesh;
    group1631870305: THREE.Mesh;
    group1639888595: THREE.Mesh;
    group188804331: THREE.Mesh;
    group1982090435: THREE.Mesh;
    group2031044348: THREE.Mesh;
    group2085192078: THREE.Mesh;
    group2115554823: THREE.Mesh;
    group2130073709: THREE.Mesh;
    group2131501692: THREE.Mesh;
    group354029567: THREE.Mesh;
    group35764393: THREE.Mesh;
    group396267525: THREE.Mesh;
    group51422144: THREE.Mesh;
    group524729728: THREE.Mesh;
    group541733156: THREE.Mesh;
    group618472546: THREE.Mesh;
    group627458418: THREE.Mesh;
    group646619783: THREE.Mesh;
    group721205586: THREE.Mesh;
    group806411317: THREE.Mesh;
    group861517382: THREE.Mesh;
    group944565295: THREE.Mesh;
  };
  materials: {
    mat22: THREE.MeshStandardMaterial;
    mat17: THREE.MeshStandardMaterial;
    mat21: THREE.MeshStandardMaterial;
    mat15: THREE.MeshStandardMaterial;
    mat9: THREE.MeshStandardMaterial;
  };
};

export default function Model(props: JSX.IntrinsicElements["group"]) {
  const group = useRef<THREE.Group>();
  const { nodes, materials } = useGLTF("/models/computer.glb") as GLTFResult;
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        material={materials.mat22}
        geometry={nodes.group24878451.geometry}
        rotation={[1.69, -0.06, 0.01]}
      >
        <mesh
          material={materials.mat22}
          geometry={nodes.group1127867106.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1139380957.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1164002630.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1215636041.geometry}
        />
        <mesh
          material={materials.mat17}
          geometry={nodes.group1262710399.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1312281953.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1344882062.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1412601270.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1420559667.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1506597832.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1625508101.geometry}
        />
        <mesh
          castShadow
          material={materials.mat21}
          geometry={nodes.group1631870305.geometry}
        />
        <mesh
          castShadow
          material={materials.mat21}
          geometry={nodes.group1639888595.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group188804331.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group1982090435.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group2031044348.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group2085192078.geometry}
        />
        <mesh
          material={materials.mat15}
          geometry={nodes.group2115554823.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group2130073709.geometry}
        />
        <mesh
          material={materials.mat17}
          geometry={nodes.group2131501692.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group354029567.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group35764393.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group396267525.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group51422144.geometry}
        />
        <mesh
          material={materials.mat9}
          geometry={nodes.group524729728.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group541733156.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group618472546.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group627458418.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group646619783.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group721205586.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group806411317.geometry}
        />
        <mesh
          material={materials.mat15}
          geometry={nodes.group861517382.geometry}
        />
        <mesh
          material={materials.mat22}
          geometry={nodes.group944565295.geometry}
        />
      </mesh>
    </group>
  );
}

useGLTF.preload("/models/computer.glb");
